module.exports = __webpack_public_path__ + "fonts/Colfax-Bold.b197a078.otf";